import React from "react";
import { toast } from "@catchoftheday/cg-components";
import { ToastContent } from "./components/index.js";
import { HEADER_TOAST_CONTAINER_ID } from "./consts.js";
export const createToast = ({ toastContent, toastId, autoClose = 5000, }) => toast(<ToastContent {...toastContent}/>, {
    containerId: HEADER_TOAST_CONTAINER_ID,
    position: "top-center",
    autoClose,
    toastId,
});
//# sourceMappingURL=createToast.jsx.map